import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getNotificationsChangeRequest,
  getNotificationsInfoRequest,
} from "../../../http/requests/notifications.http";
import { getExamsRequest } from "../../../http/requests/exam.http";

export const fetchGetNotificationsInfo = createAsyncThunk("notifications/getCounts", async () => {
  const response = await getNotificationsInfoRequest();
  return response.data;
});
export const fetchNotificationsChangeRequest = createAsyncThunk(
  "notifications/changeRequest",
  async () => {
    const response = await getNotificationsChangeRequest();
    return response.data;
  }
);
export const fetchGetExams = createAsyncThunk("notifications/getExams", async () => {
  const response = await getExamsRequest();
  return response.data;
});
